import View from '../../view.js';
import DataTables from '../../components/dataTables.js';
import moment from 'moment-timezone';

class ExporterJobs extends View {
  constructor(props = {}) {
    super(props);
  }

  get dom() {
    return {
      TABLE: '.exporter-jobs',
    };
  }

  get events() {
    return {
      'click #trigger-exporters': 'trigger',
      'click .restore-exporter-job': 'restore',
    };
  }

  _ensureDefaultElement() {
    this._setElement('#main-content');
  }

  destroy() {
    if (this._exportersJobsSubscriptionId) {
      Messenger.off(
        `/${currentCustomer}/exporters_jobs`,
        this._exportersJobsSubscriptionId,
      );
      this._exportersJobsSubscriptionId = null;
    }
  }

  trigger(e) {
    var button = $(e.target);

    button.prop('disabled', true);

    $.ajax({
      type: 'GET',
      url: '/' + currentCustomer + '/exporters_jobs/trigger',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
      },
    })
      .done(function () {
        button.prop('disabled', false);
      })
      .fail(() => {
        alert('There was a problem to trigger the exporters.');
      });
  }

  restore(e) {
    e.stopPropagation();
    var button = $(e.target).closest('.restore-exporter-job');
    var row = button.closest('tr');
    var jobId = button.data('job-id');
    // Get "Finished at" value directly from the table cell (column index 2)
    var finishedAt = row.find('td:eq(2)').text().trim();
    var backupFilePath = button.data('job-backup-file');

    var confirmationModal = new IO.Views.ConfirmationModal({
      el: '#confirmation-modal',
      closable: false,
    });

    confirmationModal.on('modalContentSet', (el) => {
      if (el.find('#reasonInput').length > 0) {
        el.find('#ok-link').toggleClass('disabled');
      }
      el.find('.Component-Timezone').each(function () {
        new window.Timezone($(this));
      });
    });

    var disabledMeta =
      typeof exportersDisabledMetadata !== 'undefined'
        ? exportersDisabledMetadata
        : null;

    // Build the message with job details table
    var message = JST['templates/exporters_jobs/restore_confirmation']({
      jobId: jobId,
      finishedAt: finishedAt,
      backupFilePath: backupFilePath,
      exportersEnabled: exportersEnabled ?? true,
      exportersDisabledMetadata: disabledMeta,
    });

    confirmationModal.show(message, (answer) => {
      confirmationModal.removeListener();
      if (!answer) {
        return;
      }

      let reason = $('textarea[name="exporters_enabled_reason"]').val();
      const formData = new FormData();

      if (reason) {
        formData.append('exporters_disabled_reason', reason);
      }
      button.prop('disabled', true);

      $.ajax({
        type: 'POST',
        url:
          '/' + currentCustomer + '/exporters_jobs/' + jobId + '/restore_data',
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        },
      }).always(() => {
        button.prop('disabled', false);
        Turbolinks.visit(window.location.href);
      });
    });
  }

  render() {
    let table = this.$(this.dom.TABLE),
      options;

    options = {
      serverSide: true,
      el: table,
      columns: window.da_grid_columns,
      filter: true,
      fixed: false,
      ajaxSource: table.data('source'),
      sorting: [[0, 'desc']],
      createdRow: function (row, data) {
        if (data[data.length - 1] === null) {
          $(row).addClass('no-click');
        }
        let statusColumnIndex =
          window.da_grid_columns[5]?.sTitle === 'Status' ? 5 : 6;
        if (
          data[statusColumnIndex] === 'failed' ||
          data[statusColumnIndex] === 'partially_failed'
        ) {
          $(row)
            .find('td:eq(' + statusColumnIndex + ')')
            .addClass('capitalize');
          $(row)
            .find('td')
            .addClass(
              data[statusColumnIndex] == 'failed' ? 'error' : 'warning',
            );
        }
      },
      rowCallback: function (row, data, index) {
        let statusColumnIndex =
          window.da_grid_columns[5]?.sTitle === 'Status' ? 5 : 6;
        $('td:eq(' + statusColumnIndex + ')', row).html(
          data[statusColumnIndex].replace('_', ' '),
        );

        // Replace Message column content with "Click for details" if there's relevant content
        let hasRelevantContent = data[data.length - 1];
        if (hasRelevantContent) {
          let messageColumnIndex = -1;
          for (let i = 0; i < window.da_grid_columns.length; i++) {
            if (window.da_grid_columns[i].sTitle === 'Message') {
              messageColumnIndex = i;
              break;
            }
          }
          if (messageColumnIndex >= 0) {
            let messageCell = $('td:eq(' + messageColumnIndex + ')', row);
            // Replace the message content with just "Click for details"
            messageCell.html(
              '<span class="click-for-details">Click for details.</span>',
            );
          }
        }

        // Find Actions column and add restore button if user can restore
        let actionColumnIndex = -1;
        for (let i = 0; i < window.da_grid_columns.length; i++) {
          if (window.da_grid_columns[i].sTitle === 'Actions') {
            actionColumnIndex = i;
            break;
          }
        }

        if (actionColumnIndex >= 0) {
          let actionCell = $('td:eq(' + actionColumnIndex + ')', row);
          let jobId = data[0];
          let backupFilePath = data[data.length - 2];

          if (
            jobId &&
            backupFilePath &&
            String(backupFilePath).trim() &&
            index > 0
          ) {
            actionCell.html(
              '<button class="ui small icon button restore-exporter-job" ' +
                'data-job-id="' +
                jobId +
                '" ' +
                'data-job-backup-file="' +
                String(backupFilePath).replace(/"/g, '&quot;') +
                '" ' +
                'title="Restore from Backup">' +
                '<i class="history icon"></i>' +
                '</button>',
            );
          } else {
            actionCell.html('');
          }
        }
      },
    };

    options.aoColumnDefs = [
      {
        aTargets: [1, 2],
        mRender: function (data) {
          return (
            data &&
            moment(data)
              .tz(moment.tz.guess())
              .format('dddd, MMMM Do YYYY, h:mm:ss a z')
          );
        },
      },
    ];

    this.table = new DataTables(options);
    this.table.start();
  }

  afterRender() {
    const channel = `/${currentCustomer}/exporters_jobs`;
    this._exportersJobsSubscriptionId = Messenger.on(channel, () => {
      if (this.table) {
        this.table.reload();
      }
    });

    // Adds a custom event in a way that the view could undelegate on navigation
    this.delegateEventTo(`${this.dom.TABLE} tbody`, 'click', 'td', (e) => {
      // Return if clicking on restore button
      if ($(e.target).closest('.restore-exporter-job').length > 0) {
        return;
      }

      let instance = new jQuery.fn.dataTable.Api(this.table.table.fnSettings()),
        tr = this.$(e.target).closest('tr'),
        row = instance.row(tr),
        data = row.data();

      if (!data[data.length - 1]) {
        return;
      } // Return if there's no job failure output

      if (row.child.isShown()) {
        row.child.hide();
      } else {
        let content = data[data.length - 1];
        let preContent = `<pre style="white-space: pre-wrap; word-wrap: break-word; word-break: break-all; max-width: 100%; overflow-wrap: break-word;">${content}</pre>`;
        row.child(preContent).show();
      }
    });
  }
}

module.exports = ExporterJobs;
